import { Card } from '@george-labs.com/design-system';
import type { COLOR } from '@george-labs.com/design-system';

import type { Severity } from '@api-client/temporary-messages';

const severityToCardColorMap: Record<Severity, COLOR> = {
    ERROR: Card.COLOR.UI_RED_WEAK,
    INFO: Card.COLOR.UI_BLUE_WEAK,
    WARNING: Card.COLOR.UI_YELLOW_WEAK,
};

export function getSeverityCardColor(severity: Severity): COLOR {
    return severityToCardColorMap[severity];
}
